import React, {Component} from 'react';
import { connect } from 'react-redux';
import iconPath from "../../../helpers/iconHelper";
import { bindActionCreators } from 'redux';
import { withRouter } from "react-router-dom";

class PromotionHeader extends Component {
    constructor(props) {
      super(props);
      this.state = {
        headerData : {},
        membership : this.props.promotionHeader.user.membership,
        name       : this.props.promotionHeader.user.full_name,
        image      : this.props.promotionHeader.user.image,
        country    : this.props.promotionHeader.user.country_name,
        page       : this.props.promotionPage
      };
    }
    componentDidMount() {  
    }
    
    UNSAFE_componentWillReceiveProps(nextProps,prevProps,prevState){  
      if(this.state.page == 'Detail'){
        this.setState({
          membership : nextProps.promotiondetail.promotion_creator_membership,
          name       : nextProps.promotiondetail.promotion_creator_name,
          image      : nextProps.promotiondetail.promotion_creator_image,
          country    : nextProps.promotiondetail.promotion_creator_country_name
        })
      }else{
        this.setState({
          membership : nextProps.promotionHeader.user.membership,
          name       : nextProps.promotionHeader.user.full_name,
          image      : nextProps.promotionHeader.user.image,
          country    : nextProps.promotionHeader.user.country_name
        })
      }  
    }

    render() {
        return (
            <div className="cover_pic">
                <img className={(this.state.membership == 'GOLD') ? "user gold_user" : "user"} src={(this.state.image != '') ? this.state.image : iconPath['DEFAULTUSER']} 
                onError = {(e) => {
                    e.target.src = iconPath['DEFAULTUSER']
                }}
                />
                <h2>{this.state.name}</h2>
                <span>{this.state.country}</span>
            </div>
        );
  }
}
const mapStateToProps = state => {
  return {
    promotionHeader : state.login,
    promotiondetail : state.promotiondetail.promotionDetail,   
  }
}
const mapDispatchToProps = dispatch => {
  return {}
}
export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(PromotionHeader));

